import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ISessionService, IWebSocketService } from '@insight/services';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

	title = 'app';

	constructor(
		private sessionService: ISessionService,
		private websocketService: IWebSocketService,
		private router: Router
	) { }

	ngOnInit() {
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				if (!this.websocketService.isConnected) {
					return this.websocketService.connect();
				}
				this.websocketService.invoke('/sys/connection/update-current-url', window.location.href);
			}
		});

		this.websocketService.connect();

		this.websocketService.onOpen.subscribe(() => {
			console.log('Websocket connected');

			if (this.websocketService.isConnected) {
				this.websocketService.invoke('/sys/connection/update-current-url', window.location.href);
			}
		});

		this.websocketService.onError.subscribe(() => {
			console.log('Websocket error');
		});

		this.websocketService.onClose.subscribe(() => {
			console.log('Websocket closed');
		});

		this.websocketService.onAuthLogout.subscribe(() => {
			const returnUrl = this.router.url;
			this.sessionService.logout();
			this.websocketService.clearToken();
			this.websocketService.close();
			this.router.navigate(['/auth/login'], {
				queryParams: { returnUrl }
			});
		});
	}

}
